import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "title", "ariaLabel", "svgStyles"];
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSVGIconBase = styled.svg.withConfig({
  displayName: "SvgIconBase__StyledSVGIconBase",
  componentId: "tpx5h2-0"
})(["", ""], ({
  $svgStyles
}) => $svgStyles);
export const SVGIconBase = _ref => {
  let {
      children,
      title,
      ariaLabel,
      svgStyles
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(StyledSVGIconBase, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-label": ariaLabel,
    $svgStyles: svgStyles
  }, rest, {
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, children]
  }));
};